import React, { Component } from "react";
import { connect } from "react-redux";
import { ClimbingBoxLoader } from 'react-spinners';

import NavigationBar from "../../components/NavigationBar";
import FixedFooter from "../../components/FixedFooter";
import AccountInfoContainer from "./components/AccountInfoContainer";
import FbWrapper from '../../lib/FirebaseWrapper';
import RobinhoodApi from '../../lib/RobinhoodApi';

const styles = {
  body: {
    display: "grid",
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "50px"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 60,
    paddingRight: 60,
    backgroundColor: "#4990E2",
    borderRadius: 5,
    boxShadow: `10px 30px 70px #9E9E9E`,
    justifyContent: "center",
    alignItems: "center"
  },
};

class LiveTradingView extends Component {
  constructor() {
    super();
    this.state = {
      token: undefined,
      accounts: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    if (!this.state.isLoading) {
      return;
    }

    const accountID = this.props.authUser.uid;
    FbWrapper.fetchRobinhoodToken(accountID, (token) => {
      RobinhoodApi.fetchData(token, 'accounts/',accounts =>
        this.setState({ token, accounts, isLoading: false })
      );
    });
  }

  _loadingView = () =>
    <ClimbingBoxLoader
      className='loader'
      color={'#36D7B7'}
      loading={this.state.isLoading}
    />;

  _mainView() {
    var view = !!this.state.token
      ? <AccountInfoContainer accounts={this.state.accounts}/>
      : <div style={styles.container}>
          <p style={styles.tokenTitle}>You do not have a token yet</p>
          <button
            className='btn-submit'
            onClick={() => this.props.history.push("/submit-token")}
          >
            Submit My Token
          </button>
        </div>;
    return view;
  }

  render() {
    var view = this.state.isLoading ? this._loadingView() : this._mainView();
    return (
      <div>
        <NavigationBar history={this.props.history} />
        <div style={styles.body}>
          {view}
        </div>
        <FixedFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser
})

export default connect(mapStateToProps)(LiveTradingView)



// WEBPACK FOOTER //
// ./src/views/LiveTradingView/index.js